/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { BoxWithSwitch } from "./BoxWithSwitch";
import { BusinessContextSelector } from "./BusinessContextSelector";
import { Included } from "./types";

type Props = {
  included: Included;
  setIncluded: React.Dispatch<React.SetStateAction<Included>>;
};

export function IncludedTypeSelector({ included, setIncluded }: Props) {
  return (
    <>
      <BoxWithSwitch
        checked={included.businessContext.checked}
        label="Include Business Context"
        description="The report will include applications and environments,
                    presented in the selected Business Context  for the selected Billing Period"
        onChange={() =>
          setIncluded((prevState) => ({
            ...prevState,
            businessContext: {
              ...prevState.businessContext,
              checked: !prevState.businessContext.checked,
            },
          }))
        }
      >
        {included.businessContext.checked && (
          <BusinessContextSelector
            value={included.businessContext.value}
            onChange={(id) =>
              setIncluded((prevState) => ({
                ...prevState,
                businessContext: {
                  ...prevState.businessContext,
                  value: id,
                },
              }))
            }
          />
        )}
      </BoxWithSwitch>
    </>
  );
}
